import { MenuItem } from '@mui/material';
import styled from 'styled-components';

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;
